var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:_vm.props.status},[_c('div',{staticClass:"status"},[_vm._v(_vm._s(_vm._f("translate")(("status." + (_vm.props.status)))))])])}
var staticRenderFns = []

export { render, staticRenderFns }